import * as React from 'react';
import {Slot} from '@radix-ui/react-slot';
import {type VariantProps} from 'class-variance-authority';
import {cn} from '../lib/cn';
import {buttonGroupVariants} from './buttonGroupVariants';

export interface ButtonGroupProps
  extends React.ComponentProps<'div'>, VariantProps<typeof buttonGroupVariants> {}

export function ButtonGroup({
  className,
  orientation,
  seamless,
  ...props
}: ButtonGroupProps) {
  return (
    <div
      role="group"
      data-slot="button-group"
      data-orientation={orientation}
      className={cn(buttonGroupVariants({orientation, seamless}), className)}
      {...props}
    />
  );
}

ButtonGroup.displayName = 'ButtonGroup';

export interface ButtonGroupTextProps extends React.ComponentProps<'div'> {
  asChild?: boolean;
}

export function ButtonGroupText({
  className,
  asChild = false,
  ...props
}: ButtonGroupTextProps) {
  const Comp = asChild ? Slot : 'div';

  return (
    <Comp
      data-slot="button-group-text"
      className={cn(
        'flex items-center gap-2 rounded-lg border border-[var(--chekin-color-gray-3)] bg-[var(--chekin-color-surface-input-empty)] px-2.5 text-sm font-medium text-[var(--chekin-color-brand-navy)]',
        "[&_svg:not([class*='size-'])]:size-4 [&_svg]:pointer-events-none",
        className,
      )}
      {...props}
    />
  );
}

ButtonGroupText.displayName = 'ButtonGroupText';
